module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.7-215.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.1-rc.7.md
// module id = 658
// module chunks = 339